/**
 * @typedef {Object} MeasureTypeResponseDto
 * @property {number} measureTypeId
 * @property {string} measureTypeName
 * @property {string} measureTypeCode
 * @property {string} [description]
 * @property {boolean} isActive
 * @property {string} createdDate
 * @property {string} [createdBy]
 * @property {string} [modifiedDate]
 * @property {string} [modifiedBy]
 */

/**
 * @typedef {Object} MeasureTypeLookupDto
 * @property {number} measureTypeId
 * @property {string} measureTypeName
 * @property {string} measureTypeCode
 * @property {boolean} isActive
 */

const BASE_PATH = 'v1/MeasureType';

export default function (instance) {
  return {
    /**
     * Get all measure types
     * @param {Object} [params]
     * @param {boolean} [params.includeInactive=false]
     * @returns {Promise<{data: MeasureTypeResponseDto[]}>}
     */
    getMeasureTypes(params = {}) {
      return instance.get(BASE_PATH, { params });
    },

    /**
     * Get measure type by ID
     * @param {number} id
     * @returns {Promise<{data: MeasureTypeResponseDto}>}
     */
    getMeasureType(id) {
      return instance.get(`${BASE_PATH}/${id}`);
    },

    /**
     * Get measure type lookups for dropdowns
     * @returns {Promise<{data: MeasureTypeLookupDto[]}>}
     */
    getMeasureTypeLookups() {
      return instance.get(`${BASE_PATH}/lookups`);
    }
  };
}
